<template>
    <div class="container">
        <div class="module_title">
            <span>培训管理 》投放列表</span>

        </div>
        <div class="queryBox">
            <div class="left">
                <el-form ref="ruleForm" :inline="true" style="display: flex;flex-wrap: wrap;">
                    <el-form-item label="企业名称：" prop="">
                        <el-input v-model="postForm2.enterprise_name" placeholder="请输入企业名称"
                            style="width: 200px;"></el-input>
                    </el-form-item>

                    <el-form-item label="职位名称：" prop="">
                        <el-input v-model="postForm2.position_name" placeholder="请输入职位名称" style="width: 200px;"></el-input>
                    </el-form-item>

                    <el-form-item class="form-btn" style="margin-left: 20px;">
                        <el-button type="primary" size="mini" icon="el-icon-search" @click="search">查询</el-button>
                        <el-button type="primary" size="mini" icon="el-icon-refresh-left" @click="reset">重置</el-button>
                    </el-form-item>

                </el-form>
            </div>
            <div class="right">

                <el-button class="color_limegreen">
                    投放竞价
                </el-button>

            </div>
        </div>

        <div class="content">
            <div class="left_list" :style="{ width: left_list_width }">
                <div class="left_list_title">
                    <template v-if="leftFoldshow == true">
                        <div>
                            <span class="dot userzudot"></span>
                            <span v-show="leftFoldshow == true">课程列表</span>
                        </div>
                        <div class="ico">
                            <i class="el-icon-refresh size20 pointer" @click="getList1(true)"></i>
                            <i @click="foldshowclick('left')" class="el-icon-s-fold xiaosho margin_left_10 size20"></i>
                        </div>

                    </template>
                    <i v-else @click="foldshowclick('left')" class="el-icon-s-unfold xiaosho"
                        style="font-size: 20px;flex: 1;"></i>

                </div>
                <div class="joblist" v-if="leftFoldshow">
                    <template v-if="leftList.length > 0">
                        <ul v-infinite-scroll="getList1" infinite-scroll-disabled="disabled">

                            <li class="xiaosho list_item"
                                :class="{ 'list_item_active': left_list_value == item.outline_id }"
                                v-for="(item, index) in leftList" :key="index"
                                @click="listValueChange('left', index, item)">
                                <template v-if="item.outline_id == ''">
                                    <p class="text_ellipsis">
                                        {{ item.outline_name }}
                                    </p>
                                </template>
                                <template v-else>
                                    <p class="text_ellipsis">
                                        {{ item.outline_name }}
                                    </p>
                                    <p class="text_ellipsis color7b7b7b size11">
                                        {{ item.enterprise_name }}
                                    </p>
                                </template>


                            </li>

                        </ul>
                        <p v-if="infinite_loading" style="text-align: center; padding: 10px 0;">加载中...</p>
                        <p v-if="noMore" style="text-align: center; padding: 10px 0;">没有更多了</p>

                    </template>
                    <template v-else>
                        <div class="empty">
                            <span>
                                暂无课程信息数据
                            </span>
                        </div>
                    </template>
                </div>

                <div class="joblist" v-else></div>
            </div>
            <div class="centerBox">
                <div class="centerTop">
                    <div class="tabs">
                        <div class="tabs__item" v-for="(item, index) in tabList" :key="index"
                            @click="changeTab(item.dictionary_key)" :style="{
                                'border-bottom': activeName == item.dictionary_key ? '1px solid #12618A' : 'none',
                            }">
                            <span>
                                {{ item.dictionary_value }}
                            </span>
                        </div>

                    </div>

                </div>
                <div class="data_list">

                    <el-table :data="tableData" row-key="recruitment_id" border lazy :stripe="true"
                        :highlight-current-row="true" :header-cell-style="{ background: '#eee', color: '#606266' }"
                        v-loading="loading" element-loading-background="#fff" element-loading-text="数据正在加载中"
                        element-loading-spinner="el-icon-loading" ref="refTable" :height="'100%'"
                        @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55"> </el-table-column>
                        <el-table-column prop="name" label="职位信息" :show-overflow-tooltip="true" min-width="360">
                            <template v-slot="{ row }">
                                <div class="info">
                                    <div class="img">
                                        <img :src="row.recruitment_enterprise_logo ? $imgUrl(row.recruitment_enterprise_logo) : require('@/assets/images/cr_default_logo.png')"
                                            alt="">
                                    </div>
                                    <div class="des">
                                        <div class="title">
                                            <span class="size16">
                                                {{ row.position_name }}
                                            </span>
                                            <span class="color_gray margin_left_10">
                                                <span class="padding_2">
                                                    {{ row.position_type ? row.position_type.join(' . ') : '' }}
                                                </span>
                                            </span>
                                        </div>
                                        <div class="color_gray">
                                            {{ row.position_effective_start }}
                                            -
                                            {{ row.position_effective_end }}
                                        </div>
                                        <div class="color_gray">
                                            {{ row.recruitment_enterprise_name }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="intro" label="企业标签" min-width="200" :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <template v-if="row.recruitment_enterprise_tags && row.recruitment_enterprise_tags.length">
                                    <el-tag
                                        v-for="(item, index) in row.recruitment_enterprise_tags.map(item => item.tags_value)"
                                        :key="index">{{ item }}</el-tag>
                                </template>

                            </template>
                        </el-table-column>

                        <el-table-column prop="position_bidding_state" label="投放课程名称" min-width="200"
                            :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                {{ row.outline_name }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="position_bidding_state" label="投放时间" min-width="100"
                            :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <span>
                                    {{ row.ctime_str }}
                                </span>

                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="position_bidding_state" label="当前状态" min-width="100"
                            :show-overflow-tooltip="true">
                            <template v-slot="{ row }">
                                <div v-for="item in options2" :key="item.dictionary_key">
                                    <span v-if="item.dictionary_key == row.position_bidding_state">
                                        {{ item.dictionary_value }}
                                    </span>
                                </div>

                            </template>
                        </el-table-column> -->
                        <template v-if="['2', '3'].includes(activeName)">
                            <el-table-column prop="position_bidding_state" label="原因" min-width="100"
                                :show-overflow-tooltip="true">
                                <template v-slot="{ row }">
                                    <span>
                                        {{ row.audit_fail_reason }}
                                    </span>

                                </template>
                            </el-table-column>
                        </template>
                        <template v-if="['2'].includes(activeName)">
                            <el-table-column prop="position_bidding_state" label="订单数量" min-width="100"
                                :show-overflow-tooltip="true">
                                <template v-slot="{ row }">
                                    <span>
                                        {{ row.order_num }}
                                    </span>

                                </template>
                            </el-table-column>
                        </template>

                        <el-table-column width="80" label="操作" fixed="right">
                            <template slot-scope="{row}">
                                <div class="btn_column">

                                    <template v-if="activeName == 0">
                                        <el-button @click="oper('1', row)" type="text" size="small">投放</el-button>
                                    </template>

                                    <span @click="oper('2', row)" type="text" size="small" class="pointer" v-if="row.outline_id">
                                        详情
                                    </span>
                                    <template v-if="activeName == 3">
                                        <el-button @click="oper('1', row)" type="text" size="small">投放</el-button>
                                    </template>
                                    <template v-if="row.audit_state == 1">
                                        <!-- <el-button @click="oper('3', row)" type="text" size="small">审核</el-button> -->
                                        <span @click="oper('4', row)" type="text" size="small" class="pointer">
                                            取消
                                        </span>
                                    </template>
                                    <!-- <template v-if="activeName == 2">
                                        <el-button @click="oper('5', row)" type="text" size="small"
                                            class="color_red">结束</el-button>
                                    </template> -->

                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>



            </div>

        </div>
        <div class="cr_footer">
            <div class="footer_left">
                <i class="el-icon-place"></i>
                <div id="box">
                    <ul id="con1" :class="{ anim: animate == true }">
                        <li v-for='item in items' :key="item.name">{{ item.name }}</li>
                    </ul>
                </div>
            </div>
            <div class="footer_right">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 30]" :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <dialogForm1 :id="1" ref="dialogForm1" @ok="ok('1')"></dialogForm1>
        <selectCourse ref="selectCourseRef" @ok="ok('2')"></selectCourse>
        <detail ref="detailRef"></detail>
    </div>
</template>

<script>
import dialogForm1 from './components/dialogForm1.vue'//课程
import selectCourse from './components/selectCourse.vue'//课程
import detail from './components/detail.vue'//课程
export default {
    components: {
        dialogForm1,
        selectCourse,
        detail
    },
    data() {
        return {
            // 招聘状态
            options1: [

            ],
            options2: [],
            options: JSON.parse(localStorage.getItem('entinfolist')),
            infinite_loading: false,
            leftListTotal: 0,
            leftListCurrentPage: 0,
            leftListPagesize: 10,
            leftList: [],
            left_list_width: '240px',
            leftFoldshow: true,
            left_list_value: '',
            rightList: [],
            right_list_width: '300px',
            rightFoldshow: true,
            right_list_value: '',

            tabList: [
                // {
                //     label: '未投放',
                //     value: '0'
                // },
                // {
                //     label: '已投放',
                //     value: '2'
                // },

                // {
                //     label: '审核中',
                //     value: '1'
                // },
                // {
                //     label: '未通过',
                //     value: '3'
                // },
                // {
                //     label: '关闭',
                //     value: '4'
                // }
            ],

            // 左侧列表参数
            postForm1: {
                page: 1,
                limit: 10,
                "outline_name": "",//名称
                "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
            },
            // 中间列表参数
            postForm2: {
                page: 1,
                limit: 10,
                "enterprise_id": localStorage.getItem('enterprise_id'),//企业唯一标识
                "enterprise_name": "",//主课程详情 ID
                "position_name": "",//课程大纲目录 ID
                "audit_state": '0',//审核状态

            },
            // 列表上方tab
            activeName: '0',
            // 分页
            pagesize: 10,
            currentPage: 1,
            total: 0,
            loading: false,
            // 课程视频选择
            checkList: [],
            // 表格数据
            tableData: [
                {}
            ],
            // 底部
            animate: false,
            items: [{ name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200120）注册数剧等等" },
            { name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200122）注册数剧等等" },
            { name: "收到人脸设备（位置：北京大学东门入口点，设备编号：AICR-200123）注册数剧等等" }],
        }
    },
    computed: {
        noMore() {
            return this.leftList.length >= this.leftListTotal && !this.infinite_loading
        },
        disabled() {
            return this.infinite_loading || this.noMore
        }
    },
    created() {
        this.getDictsData("HR-KJ-KC-TFZT", "tabList");
        this.getList1(true)
        this.getList2(true)



    },
    mounted() {
        // this.timie = setInterval(this.scroll, 2000)
    },
    methods: {
        // 获取数据字典值
        async getDictsData(dict, optionsNmae) {
            let options = [];
            await this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        dictionary_code: dict,
                    },
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        options = res.data.data.dictionary_detail;
                    } else {
                        // this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
            this[optionsNmae] = options;
        },
        scroll() {
            let con = document.getElementById('con1')
            con.style.marginTop = '-34px';
            this.animate = !this.animate;
            var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
            setTimeout(function () {
                that.items.push(that.items[0]);
                that.items.shift();
                con.style.marginTop = '0px';
                that.animate = !that.animate;  // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
                this.timie = null
            }, 1000)
        },

        // 左右列表点击收缩
        foldshowclick(type) {
            this[type + 'Foldshow'] = !this[type + 'Foldshow'];
            switch (this[type + 'Foldshow']) {
                case true:
                    this[type + '_list_width'] = type == "left" ? "240px" : "300px";

                    break;
                case false:

                    this[type + '_list_width'] = "35px";
                    break;
            }
        },
        // 左右列表点击
        listValueChange(type, index, item) {
            switch (type) {
                case 'left':
                    this[type + '_list_value'] = item.outline_id;
                    // 给添加视频课程赋值
                    this.currentPage = 1

                    this.getList2()



                    break;

                default:
                    break;
            }

        },
        changeTab(value) {
            this.activeName = value;
            this.getList2(true)

        },
        // 左侧列表
        getList1(init) {
            if (init) {
                this.showEditForm = false
                this.leftListCurrentPage = 0
            }
            this.infinite_loading = true;
            this.leftListCurrentPage++
            this.postForm1.page = this.leftListCurrentPage
            this.postForm1.limit = this.leftListPagesize


            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.trainingCourseList, {
                    data: this.postForm1
                }).then((res) => {
                    if (res.data.code == 0) {
                        if (init) {
                            this.leftList = [
                                { outline_id: '', outline_name: '全部课程' }
                            ].concat(res.data.data.data)

                        } else {
                            let arr = this.leftList.concat(res.data.data.data)
                            this.leftList = arr
                        }

                        if (init) {

                            this.left_list_value = this.leftList[0].outline_id

                            this.getList2()






                        }
                        this.leftListTotal = res.data.data.total

                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                    this.infinite_loading = false;
                }).catch((err) => { this.infinite_loading = false; });
        },
        search() {
            // console.log(value);
            // this.postForm1.enterprise_id = value
            this.currentPage = 1
            this.getList2(true)


        },
        oper(type, row) {

            switch (type) {
                case '1'://投放
                    this.$refs.selectCourseRef.dialogVisible = true
                    this.$refs.selectCourseRef.init(row)
                    // this.$tools
                    //     .asyncPost(
                    //         this,
                    //         this.$baseUrl.launchListEdit, {
                    //         data: {
                    //             "recruitment_id": row.recruitment_id,
                    //             "audit_state": "1",

                    //         }
                    //     }).then((res) => {
                    //         if (res.data.code == 0) {
                    //             this.$message({ type: "success", message: '投放申请成功' });
                    //             // 重新渲染右侧列表

                    //             this.getList2(true)

                    //         } else {
                    //             this.$message({ type: "error", message: res.data.msg });
                    //         }
                    //     })
                    break;
                case '2'://详情

                    this.$refs.detailRef.dialogVisible = true
                    this.$refs.detailRef.init(row)
                    break;
                case '3'://审核
                    this.$refs.dialogForm1.dialogVisible = true
                    this.$refs.dialogForm1.init(row)

                    break;
                case '4'://取消
                    this.$MessageBox.confirm('确定要取消吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$tools
                            .asyncPost(
                                this,
                                this.$baseUrl.launchListCancel, {
                                data: {
                                    recruitment_id: row.recruitment_id,
                                }
                            }).then((res) => {
                                if (res.data.code == 0) {
                                    this.$message({
                                        type: "success",
                                        message: "取消成功!",
                                    });
                                    this.getList2(true);
                                } else {
                                    this.$message({ type: "error", message: res.data.msg });
                                }

                            }).catch((err) => { });
                    })

                    break;
                case '5'://结束

                    this.$MessageBox.confirm('确定要结束吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$tools
                            .asyncPost(
                                this,
                                this.$baseUrl.launchListDel, {
                                data: {
                                    recruitment_id: row.recruitment_id,
                                }
                            }).then((res) => {
                                if (res.data.code == 0) {
                                    this.$message({
                                        type: "success",
                                        message: "取消成功!",
                                    });
                                    this.getList2(true);
                                } else {
                                    this.$message({ type: "error", message: res.data.msg });
                                }

                            }).catch((err) => { });
                    })

                    break;
                default:
                    break;
            }
        },
        ok(type) {
            switch (type) {
                case '1':
                    this.getList2(true)
                    break;
                case '2':
                    this.getList2(true)
                    break;
                default:
                    break;
            }
        },
        reset() {
            let obj = {
                enterprise_name: '',//姓名
                position_name: '',//手机号
            }
            Object.keys(this.postForm2).forEach((key) => {
                this.postForm2[key] = obj[key];
            });

            this.currentPage = 1;

            this.getList2(true)
        },
        // 中间列表数据
        getList2(init) {
            if (init || ['1', '2', '3', '4'].includes(this.activeName)) {
                this.tableData = []
                this.loading = true;
                this.postForm2.page = this.currentPage
                this.postForm2.limit = this.pagesize
                this.postForm2.audit_state = this.activeName

                let obj = {
                    "outline_id": this.left_list_value,

                }
                let data = {

                }
                switch (this.activeName) {
                    case '1':
                    case '2':
                    case '3':
                    case '4':

                        data = Object.assign(obj, this.postForm2)
                        break;
                    case '0':

                        data = this.postForm2
                        break;

                    default:
                        break;
                }

                this.$tools
                    .asyncPost(
                        this,
                        this.$baseUrl.launchList, {
                        data
                    }).then((res) => {
                        if (res.data.code == 0) {

                            this.tableData = res.data.data.data

                            this.total = res.data.data.total
                            this.$nextTick(() => {
                                this.$refs.refTable.doLayout(); //重新渲染表格
                            });
                        } else {
                            this.$message({ type: "error", message: res.data.msg });
                        }
                        this.loading = false;
                    }).catch((err) => { this.loading = false; });
            }



        },
        handleSelectionChange(val) {
            this.checkList = val
        },

        handleSizeChange: function (size) {
            this.pagesize = size; //每页下拉显示数据
            this.getList2(true);
        },
        handleCurrentChange: function (currentPage) {
            this.currentPage = currentPage; //点击第几页
            this.getList2(true);
        },
    }

}
</script>

<style scoped lang="less" src="./index.less"></style>